var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"feedback-view"},[(_vm.mode === 'error')?_c('ErrorView',{attrs:{"hidetitle":_vm.hidetitle,"title":_vm.title,"subtitle":_vm.msg}}):_c('SuccessView',{attrs:{"title":_vm.title,"subtitle":_vm.msg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }